import { Box } from '@mui/material';
import { useEffect } from 'react';

import {
  DEFAULT_LEFT_SIDEBAR_WIDTH,
  DEFAULT_RIGHT_SIDEBAR_WIDTH,
} from '@verantos-dev/core-annotation-tool';
import { useFeatureFlagSplit } from '@verantos-dev/core-utils';
import { LoadingSpinner } from '@verantos-dev/shared-components';
import { ResizeHandle, useResizeHandle } from '@verantos-dev/ui-annotation-tool';

import { AnnotationConfig } from './components/AnnotationConfig/AnnotationConfig';
import { AnnotationContent } from './components/AnnotationContent/AnnotationContent';
import { useAnnotationContent } from './components/AnnotationContent/useAnnotationContent';
import { NoteListSidebar } from './components/NoteListSidebar/NoteListSidebar';
import { useAnnotationScreen } from './useAnnotationScreen';

export const AnnotationScreen = () => {
  const { annotationStarted } = useAnnotationScreen();

  const {
    startRightResize,
    startLeftResize,
    setRightInitialWidthToDefault,
    rightWidth,
    leftWidth,
  } = useResizeHandle({
    initialLeftWidth: DEFAULT_LEFT_SIDEBAR_WIDTH,
    initialRightWidth: DEFAULT_RIGHT_SIDEBAR_WIDTH,
  });

  // Second call to pick up the shared workspace query's loading flag at the
  // screen level (RTK Query dedupes the request) — NoteListSidebar,
  // AnnotationContent, and AnnotationConfig all read the same query.
  const { isEncounterDataLoading } = useAnnotationContent();
  // TODO: cleanup with cp_annotation_show_dashboard_loading_spinner ff
  const showLoadingSpinner = useFeatureFlagSplit(
    'cp_annotation_show_dashboard_loading_spinner'
  ) as boolean;
  const isLoading = isEncounterDataLoading;

  useEffect(() => {
    setRightInitialWidthToDefault();
  }, [annotationStarted]);

  return showLoadingSpinner && isLoading ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 51px)',
        minHeight: '400px',
      }}
    >
      <LoadingSpinner id="annotationScreenLoading" />
    </Box>
  ) : (
    <Box sx={{ display: 'flex' }}>
      <NoteListSidebar leftWidth={leftWidth} />
      <ResizeHandle onMouseDown={(e: React.MouseEvent) => startLeftResize(e)} />
      <AnnotationContent />
      {annotationStarted && (
        <ResizeHandle onMouseDown={(e: React.MouseEvent) => startRightResize(e)} />
      )}
      <AnnotationConfig rightWidth={rightWidth} />
    </Box>
  );
};
